import React, {useEffect, useState} from 'react';
import bn from "../../../utils/bemnames";
import Event from "./Event";
import {fetchEventData, IEventDataResponse} from '../../../api/outright-odds';
import {oddsFormats} from '../../../utils/types';
import LoadingBlock from '../../LoadingBlock';
import CompetitorLastResultsBar from '../EventTopBanner/CompetitorLastResultsBar';
import {DateTime} from 'luxon';
import EventOdds from './EventOdds';
import {_t} from '../../../utils/translations';
import {useGlobalState} from "../../../contexts/GlobalState";

interface IProps {
  eventId: number,
  competitorId: number,
  languageId: number,
  allowedProvidersIds: number[],
  outLinkFolder: string|null|undefined;
  oddsFormat: oddsFormats,
}

const bem = bn.create('outright-odds-desktop');

const EventDataDesktop: React.FC<IProps> = ({eventId, outLinkFolder, oddsFormat, competitorId, languageId, allowedProvidersIds = []}) => {
    const [eventDataResponse, setEventDataResponse] = useState<IEventDataResponse|null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [requestFailed, setRequestFailed] = useState<boolean>(false)
    const {globalState} = useGlobalState()

    useEffect(() => {
      fetchEventData({
        eventId: eventId,
        languageId: languageId,
        competitorId: competitorId,
        allowedProvidersIds: allowedProvidersIds,
        widgetId: globalState.widget?.id
      }).then((r: IEventDataResponse) => {
        setEventDataResponse(r)
        setLoading(false)
      }).catch(() => {
        setRequestFailed(true)
        setLoading(false)
      })
    }, [eventId, languageId, competitorId, allowedProvidersIds, globalState.widget?.id])

    return (
      <>
        {!requestFailed && (
          <>
            {loading ? <LoadingBlock isMobile={false} height={115} heightMobile={115}/> : (
              <>
                {eventDataResponse && eventDataResponse.bestOdds.bestProvider && (
                  <div className={bem.e('event-info')}>
                    <div className={bem.e('column')}>
                      <div className={bem.e('label')}>{_t('Last 5')}</div>
                      <CompetitorLastResultsBar
                        meetingResults={eventDataResponse.prevMeetings.map(prevMeeting => prevMeeting.meetingResult)}
                      />
                    </div>
                    <div className={bem.e('column')}>
                      <div className={bem.e('label')}>{_t('Next')}</div>
                      <div className={bem.e('label')}>
                        {DateTime.fromISO(eventDataResponse.event.userStartTime).toLocaleString({
                          day: '2-digit',
                          month: 'short',
                        })}
                      </div>
                      <div className={bem.e('label')}>
                        {DateTime.fromISO(eventDataResponse.event.userStartTime).toLocaleString({
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </div>
                    </div>
                    {eventDataResponse.event.eventCompetitors && eventDataResponse.event.eventCompetitors.length > 0 && (
                      <div className={bem.e('column')}>
                        <div className={bem.e('label')}/>
                        <div className={bem.e('event')}>
                          <Event isMobile={false} eventCompetitors={eventDataResponse.event.eventCompetitors}/>
                        </div>
                      </div>
                    )}
                    <div className={bem.e('column')}>
                      {globalState.widget !== null && (
                        <EventOdds
                          isMobile={false}
                          providerDeal={eventDataResponse.providerDeals[0] ?? undefined}
                          outLinkFolder={outLinkFolder}
                          provider={eventDataResponse.bestOdds.bestProvider}
                          widgetId={globalState.widget?.id}
                          eventId={eventId}
                          odds={eventDataResponse.bestOdds.bestOdds}
                          oddsFormat={oddsFormat}
                        />
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </>
    )
  }

  export default EventDataDesktop;
